import type { EditorState } from "../../vendor/src/features/remotion-editor/editor/state/types";
import { hasPendingTimelineEdit } from "./edit-ownership";
import { detachVideoAudio } from "./media-tools";
import { restoreVideoAudio } from "./restore-video-audio";

/** The clicked video is authoritative even when another video remains selected. */
export function clipAudioMenuAction(
  state: EditorState,
  clipId: string,
  kind: "detach" | "restore",
  id: () => string,
) {
  if (hasPendingTimelineEdit(state))
    throw Error("이동이나 시간 입력을 마친 뒤 다시 시도해 주세요.");
  if (state.undoableState.items[clipId]?.type !== "video")
    throw Error("영상 클립을 다시 선택해 주세요.");
  const accompanyingAudio = state.selectedItems.includes(clipId)
    ? state.selectedItems.filter(
        (key) => state.undoableState.items[key]?.type === "audio",
      )
    : [];
  const before = state.undoableState;
  const document =
    kind === "detach"
      ? detachVideoAudio(before, [clipId], id)
      : restoreVideoAudio(before, [clipId, ...accompanyingAudio]);
  return {
    undoableState: document,
    selectedItems: [clipId],
    assetStatus: {
      ...state.assetStatus,
      ...Object.fromEntries(
        Object.keys(document.assets)
          .filter((key) => !before.assets[key])
          .map((key) => [key, { type: "uploaded" as const }]),
      ),
    },
  };
}
